import { SimpleAndFilter } from "@impero-com/common/utils/indexing";
import { assertNever } from "@impero-com/common/utils/obj";

import { Codecs } from "org/pageState/types";
import { ReportColumnId } from "org/reports/list/columns";

import {
    decodeReportsAllPageState,
    encodeReportsAllPageState,
    ReportsAllPageStateWithType,
} from "./all";
import {
    decodeReportsClassificationPageState,
    encodeReportsClassificationPageState,
    ReportsClassificationPageStateWithType,
} from "./classification";
import {
    decodeReportsDatasheetPageState,
    encodeReportsDatasheetPageState,
    ReportsDatasheetPageStateWithType,
} from "./datasheet";
import {
    decodeReportsStatusPageState,
    encodeReportsStatusPageState,
    ReportsStatusPageStateWithType,
} from "./status";
import {
    decodeReportsWorkloadPageState,
    encodeReportsWorkloadPageState,
    ReportsWorkloadPageStateWithType,
} from "./workload";

type ReportsPageStateWithType =
    | ReportsAllPageStateWithType
    | ReportsStatusPageStateWithType
    | ReportsClassificationPageStateWithType
    | ReportsWorkloadPageStateWithType
    | ReportsDatasheetPageStateWithType;

type ReportsPageStateType = ReportsPageStateWithType["type"];

function encodeReportsPageState(
    raw: ReportsPageStateRaw
): ReportsPageStateWithType {
    switch (raw.pageType) {
        case "ReportsAll":
            return encodeReportsAllPageState(raw);
        case "ReportsStatus":
            return encodeReportsStatusPageState(raw);
        case "ReportsClassification":
            return encodeReportsClassificationPageState(raw);
        case "ReportsWorkload":
            return encodeReportsWorkloadPageState(raw);
        case "ReportsDatasheet":
            return encodeReportsDatasheetPageState(raw);
        default:
            return assertNever(raw.pageType);
    }
}

function decodeReportsPageState(
    input: ReportsPageStateWithType
): ReportsPageStateRaw {
    switch (input.type) {
        case "ReportsAll":
            return decodeReportsAllPageState(input);
        case "ReportsStatus":
            return decodeReportsStatusPageState(input);
        case "ReportsClassification":
            return decodeReportsClassificationPageState(input);
        case "ReportsWorkload":
            return decodeReportsWorkloadPageState(input);
        case "ReportsDatasheet":
            return decodeReportsDatasheetPageState(input);
        default:
            return assertNever(input);
    }
}

const pageStateReportsCodecs: Codecs<
    ReportsPageStateRaw,
    ReportsPageStateWithType
> = {
    encode: encodeReportsPageState,
    decode: decodeReportsPageState,
};

interface ReportsPageStateRaw {
    pageType: ReportsPageStateType;
    version: number;
    filter: SimpleAndFilter | null;
    visibleColumnIds: Set<ReportColumnId>;
    leftSideMenuCollapsed: boolean;
}

export { pageStateReportsCodecs };

export type {
    ReportsPageStateRaw,
    ReportsPageStateType,
    ReportsPageStateWithType,
};
